import type { ReactNode } from "react";

export function SectionHeading({ children }: { children: ReactNode }) {
	return (
		<h3 className="text-base font-medium text-muted-foreground px-2 mb-2 first:mt-0 mt-6">
			{children}
		</h3>
	);
}
